import React, { forwardRef, JSX } from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import { SingleInputDateRangeFieldProps } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import { StyledSingleInputDateRangeField } from '../DateRanges.styles';

type FieldComponent = (<TDate>(
  props: SingleInputDateRangeFieldProps<TDate> & React.RefAttributes<HTMLInputElement>
) => JSX.Element) & { fieldType?: string };

const DateRangeInput = forwardRef((props: SingleInputDateRangeFieldProps<Date>, ref: React.Ref<HTMLInputElement>) => {
  const newProps = { ...props };

  return (
    <SingleInputDateRangeField
      {...newProps}
      ref={ref}
      label='Date range'
      variant='filled'
      InputProps={{
        endAdornment: <CalendarMonthIcon />,
        sx: StyledSingleInputDateRangeField,
      }}
    />
  );
}) as FieldComponent;

DateRangeInput.fieldType = 'single-input';
export default DateRangeInput;
